function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var Night = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "NightIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "M15.5 17A8.5 8.5 0 0 1 8.497 3.681c.291-.422-.085-1.032-.553-.824A10.002 10.002 0 0 0 2 12c0 5.523 4.477 10 10 10 4.079 0 7.587-2.442 9.143-5.944.208-.468-.402-.844-.824-.553A8.46 8.46 0 0 1 15.5 17z"
    })
  }));
});
Night.displayName = 'NightIcon';
export default Night;